var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasCookie !== true)?_c('div',{attrs:{"id":"disclaimer"}},[_c('div',{staticClass:"disclaimer-container"},[_c('span',{staticClass:"text"},[_vm._v("This site uses cookies and external scripts to improve your experience.")]),_vm._v(" "),_c('button',{staticClass:"button",on:{"click":_vm.accept}},[_vm._v("ACCEPT")])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54ee3390","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Disclaimer.vue
// module id = null
// module chunks = 